import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ScheduleUnwrapped as Schedule } from 'components/Schedule/Schedule';
import { PagePromotionCta } from 'components/PagePromotion';
import modal from 'decorators/Modal/Modal';
import { ga } from 'helpers/multitrack';
import { iso8601Date } from 'helpers/time';
import { setVenueScheduleDate } from 'redux/modules/features/explore';
import { venueByIdV2, scheduleForVenue } from 'redux/saga/entities/bound';
export var mapStateToProps = function mapStateToProps(state) {
  var _state$features$explo = state.features.explore,
      venueScheduleDate = _state$features$explo.venueScheduleDate,
      venueId = _state$features$explo.venueId;
  var scheduleKey = "".concat(venueId, "_").concat(venueScheduleDate);
  var venue = venueByIdV2.data(state, venueId);
  return {
    venue: venue,
    scheduleDate: venueScheduleDate,
    schedule: scheduleForVenue.data(state, scheduleKey),
    scheduleLoading: scheduleForVenue.loading(state, scheduleKey)
  };
};
export var mapDispatchToProps = {
  setVenueScheduleDate: setVenueScheduleDate
};
export var ScheduleModalUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(ScheduleModalUnwrapped, _Component);

  function ScheduleModalUnwrapped(props) {
    var _this;

    _classCallCheck(this, ScheduleModalUnwrapped);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScheduleModalUnwrapped).call(this, props));
    _this.handleRequestScheduleForDate = props.setVenueScheduleDate.bind(_assertThisInitialized(_this));
    _this.handleOfferClick = _this.handleOfferClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ScheduleModalUnwrapped, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.setVenueScheduleDate(iso8601Date());
    }
  }, {
    key: "handleOfferClick",
    value: function handleOfferClick() {
      ga('Explore Studios', 'Clicked Studio Schedule CTA', this.props.venue.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          venue = _this$props.venue,
          schedule = _this$props.schedule,
          scheduleLoading = _this$props.scheduleLoading,
          scheduleDate = _this$props.scheduleDate;
      return React.createElement("div", {
        className: "explore__modal explore__modal--schedule"
      }, React.createElement(FormattedMessage, {
        tagName: "h4",
        id: "modal.schedule.title",
        defaultMessage: "This week at {venue}",
        values: {
          venue: venue.name
        }
      }), React.createElement(Schedule, {
        extraClass: "schedule--no-scroll explore__modal__schedule",
        noLink: true,
        expanded: true,
        hideCtas: true,
        hideDateHeader: true,
        loading: scheduleLoading,
        schedule: schedule,
        timeZone: venue.tz,
        selectedDate: scheduleDate || iso8601Date(),
        venueUrl: "/studios/".concat(venue.alias),
        numberOfDaysToShow: 7,
        onRequestScheduleForDate: this.handleRequestScheduleForDate
      }), React.createElement(PagePromotionCta, {
        extraClassForLink: "bt--primary modal__closer _optimizely_search_test",
        extraClassForWrapper: "explore__offer",
        onClick: this.handleOfferClick
      }));
    }
  }]);

  return ScheduleModalUnwrapped;
}(Component);
ScheduleModalUnwrapped.propTypes = {
  venue: PropTypes.object.isRequired,
  schedule: PropTypes.array,
  scheduleDate: PropTypes.string,
  scheduleLoading: PropTypes.bool,
  setVenueScheduleDate: PropTypes.func.isRequired
};
export var ScheduleModal = modal({
  headerClass: 'modal--640'
})(connect(mapStateToProps, mapDispatchToProps)(ScheduleModalUnwrapped));